export const examples = [
    'Gaming',
    'What are the latest trends about Tao?',
    'What are the recent sports events?',
]
